$(document).ready(function () {
function generateLooxRatingHTML(num_reviews, avg_rating) {
  num_reviews = num_reviews || 0;
  avg_rating = avg_rating || 0;
  let html = '<div class="loox-rating-content">';

  const fullStars = Math.floor(avg_rating);
  const hasHalfStar = avg_rating % 1 >= 0.25 && avg_rating % 1 < 0.75;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  const titleText = `${avg_rating} rating (${num_reviews} vote${num_reviews !== 1 ? 's' : ''})`;

  // Add full stars
  for (let i = 0; i < fullStars; i++) {
    html += createStarSVG('full', i === 0 ? titleText : null);
  }

  // Add half star
  if (hasHalfStar) {
    html += createStarSVG('half');
  }

  // Add empty stars
  for (let i = 0; i < emptyStars; i++) {
    html += createStarSVG('empty');
  }

  // Add number of reviews
  html += `<span class="loox-rating-label" aria-hidden="true">&nbsp;(${num_reviews})</span>`;
  html += '</div>';

  return html;
}

function createStarSVG(fillType, title = null) {
  return `
    <svg class="loox-icon" viewBox="0 0 24 24" data-lx-fill="${fillType}" ${title ? 'role="presentation"' : 'aria-hidden="true"'}>
      ${title ? `<title>${title}</title>` : ''}
      <use href="#looxicons-rating-icon"></use>
    </svg>
  `;
}
  function openAddWishlistModal(product, product_origin_settings, product_shipping_settings, collections, logged_in_customer_id, num_reviews, avg_rating) {
    let model = $("#addTowishListModal");
    let images = [];

    if (product?.image?.src) {
      images.push(product.image.src);
    }

    if (product?.images?.length > 0) {
      for (let i = 0; i < product.images.length; i++) {
        images.push(product.images[i].src);
      }
    }
    let images_html = "";
    for (let i = 0; i < images.length; i++) {
      images_html += `<div class="slide"><img src="${images[i]}" alt="" /></div>`;
    }
    const variations = product.variants;
    let selected_varient = variations[0];
    let options = null;
    let options_html = "";
    if (variations.length > 1) {
      options = product.options;
      for (let i = 0; i < options.length; i++) {
        options_html += `<hr class="divider" /><h3 class="section-title">Choose ${
          options[i].name
        }</h3> <div class="size-options" data-option_index="${i + 1}">`;

        for (let j = 0; j < options[i].values.length; j++) {
          console.log(options[i].values[j], selected_varient[`option${i + 1}`]);
          let selected_class =
            options[i].values[j] == selected_varient[`option${i + 1}`]
              ? "selected"
              : "";
          options_html += `<div class="size-option ${selected_class}" data-value="${options[i].values[j]}">${options[i].values[j]}</div>`;
        }
        options_html += `</div>`;
      }
    }
    let collections_html =
      '<h3 class="section-title">Collection (optional)</h3><select class="collection-select" name="collection_id"><option value="">All</option>';

    if (collections) {
      for (let i = 0; i < collections.length; i++) {
        collections_html += `<option value="${collections[i].id}">${collections[i].name}</option>`;
      }
    }

    collections_html += "</select>";

    let description = product.body_html;
    let plainText = $("<div>").html(description).text();
    plainText = plainText.substring(0, 300) + "...";

    let origin_html = "";
    if(product_origin_settings){
      origin_html = `<div class="product-origin"><span>From:</span> ${product_origin_settings.country_name}</div>`;
      origin_html += `<div class="product-shipping list"><h3>Shipping</h3>`;
      for (let i = 0; i < product_shipping_settings.length; i++) {
        let shiping_cost_html = 'Free';
        if(product_shipping_settings[i].shipping_cost > 0){
          shiping_cost_html = `${currencySymbol}${product_shipping_settings[i].shipping_cost}`;
        }
        origin_html += `<div class="product-shipping-item">
        <div class="shipping_-country">
            ${product_shipping_settings[i].country_name??"World wide"} 
        </div>
        <div class="shipping_country_cost">
            <span class="cost">${shiping_cost_html} </span>
            <span class="time">(${product_shipping_settings[i].expected_shipping_time})</span>
        </div>
        </div>`;
      }
      origin_html += `</div>`;
    }
    
    const modalHTML = `
             <h1 class="product-title n-product-title">
                    ${product.title}
             </h1>
            <form class="product-container" style="display: none;">
            
                <div class="product-gallery">
                    <div class="thumbnail-slider-card">
                        <button type="button" class="thumbnail-prev"></button>
                        <div class="thumbnail-slider">
                            ${images_html}
                        </div>
                        <button type="button" class="thumbnail-next"></button>
                    </div>

                    <div class="main-slider">
                        ${images_html}
                    </div>
                </div>
                <div class="product-info">
                    <input type="hidden" class="variation-id" name="product_variant_id" value="${selected_varient.id}" />
                    <input type="hidden" class="product-id" name="product_id" value="${product.id}" />
                   
                    <div class="product-price">
                    <span class="current-price">${currencySymbol}${selected_varient.price}</span>
                    <div class="loox-rating loox-widget">${generateLooxRatingHTML(num_reviews, avg_rating)}</div>  
                    </div>
                    <div class="product-description">
                    ${plainText}
                    </div>     
                                
                    ${options_html}
                    
                    ${collections_html}
                    <hr class="divider" />
                    <div class="button-group">
                    <div class="quantity-selector">
                        <div class="quantity-btn minus"></div>
                        <input type="number" class="quantity-input" name="quantity" value="1" readonly />
                        <div class="quantity-btn plus"></div>
                    </div>
                    <button ${product_origin_settings ? "" : "disabled"} class="add-to-cart-btn add-to-wishlist-btn-js">Add to Wishlist</button>
                    </div>
                    <div class="origin_content">
                       ${origin_html}
                    </div>

                </div>
            </form>
        `;
    model.find(".modal-content").append(modalHTML);

    model.find(".product-container").on("submit", function (e) {
      model.find(".model-content-loader").show();
      e.preventDefault();
      if (!logged_in_customer_id) {
        window.location.href = "/account/login";
        return;
      }
      const form = $(this);
      const data = form.serialize();
      fetch("/tools/api/add-to-wishlist", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: data,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          if (data.success) {
            showToast("Success", "Product added to wishlist", "success");
          } else {
            showToast("Error", data.message, "error");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          showToast("Error", "Failed to add product to wishlist", "error");
        })
        .finally(() => {
          model.find(".model-content-loader").hide();
          model.fadeOut();
        });
    });

    $(".main-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: ".thumbnail-slider",
    });

    // Initialize the thumbnail slider
    $(".thumbnail-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: ".main-slider",
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      vertical: true,
      arrows: true,
      prevArrow: $(".thumbnail-prev"), // Custom Previous Button
      nextArrow: $(".thumbnail-next"), // Custom Next Button
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            vertical: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            vertical: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            vertical: false,
          },
        },
      ],
    });

    model.find(".size-option").click(function () {
      $(this).parent().find(".size-option").removeClass("selected");
      $(this).addClass("selected");
      let selected_options = {};
      model.find(".size-option.selected").each(function () {
        selected_options[$(this).parent().data("option_index")] =
          $(this).data("value");
      });

      for (const variation of variations) {
        let is_selected = true;

        for (const key in selected_options) {
          if (selected_options[key] !== variation[`option${key}`]) {
            is_selected = false;
            break;
          }
        }

        if (is_selected) {
          selected_varient = variation;
          break; // stop once found
        }
      }
      console.log(selected_options);
      console.log(selected_varient);
      model
        .find(".current-price")
        .text(currencySymbol + selected_varient.price);
      model
        .find(".original-price")
        .text(currencySymbol + selected_varient.compare_at_price);
      model.find(".discount-badge").text(`-${selected_varient.discount}`);
      model.find(".variation-id").val(selected_varient.id);
    });

    // Quantity selector functionality
    model.find(".quantity-btn.plus").on("click", function () {
      let currentQty = parseInt(model.find(".quantity-input").val());
      model.find(".quantity-input").val(currentQty + 1);
    });

    model.find(".quantity-btn.minus").on("click", function () {
      let currentQty = parseInt(model.find(".quantity-input").val());
      if (currentQty > 1) {
        model.find(".quantity-input").val(currentQty - 1);
      }
    });

    // Add to cart functionality
    model.find(".model-content-loader").hide();
    model.find(".product-container").css("display", "flex");
  }

  $(document).on("click", ".open-add-wishlist-modal", function () {
    const modalHTML = `
            <div class="modal update" id="addTowishListModal">
                <div class="modal-content">
                    <button type="button" class="close-modal">&times;</button>
                    <div class="model-content-loader add-to-cart-loader">
                        <div class="loader"></div>
                    </div>
                </div>
            </div>

        `;

    const product_id = $(this).data("product-id");
    const product_details_url = `/tools/api/product-details/${product_id}?country=${Shopify.country}`;
    const num_reviews = $(this).data("num_reviews");
    const avg_rating = $(this).data("avg_rating");
    // Remove any existing modal
    $("#addTowishListModal").remove();
    // Append new modal HTML to body
    $("body").append(modalHTML);
    // Show the modal
    $("#addTowishListModal").fadeIn();
    fetch(product_details_url)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data?.product) {
          openAddWishlistModal(
            data.product,
            data.product_origin_settings,
            data.product_shipping_settings,
            data.collections,
            data.logged_in_customer_id,
            num_reviews,
            avg_rating
          );
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  });
});
